/**
 * Created by nijin on 8/2/17.
 */
import {Component, OnInit, ElementRef} from '@angular/core';
import {AuthService} from "../../auth/auth.service";


@Component({
  host: {
    '(document:click)': 'onDocumentClick($event)',
  },
    selector: 'nuc-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls:['./dropdown.scss']
})
export class DropdownComponent implements OnInit {
  constructor(private _eref: ElementRef,
  private authService:AuthService) { }
  isOpen: boolean = false;
  userProfile :any;
  userAccount :any;
  ngOnInit() {
    this.userProfile = this.authService.getUserProfile();
    this.authService.getProfileSubject()
      .subscribe((response)=>{
      this.userProfile = response;
      this.userAccount = this.authService.getCurrentAccount();
    });
    this.userAccount = this.authService.getCurrentAccount();

  }


    onDocumentClick(event) {
      if (!this._eref.nativeElement.contains(event.target))
       this.isOpen = false;
    }



    logout() {
      this.authService.logout();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/navigation/dropdown.component.ts